import { createI18n } from 'vue-i18n'
import en from './en.json'
import zh from './zh.json'

export type AppLocale = 'en' | 'zh'

// 不标 Record<AppLocale, ...>：宽松的 unknown 索引签名会让 vue-i18n 重载推导失败
export const messages = { en, zh }

const STORAGE_KEY = 'language'

function getInitialLocale(): AppLocale {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    return saved === 'en' || saved === 'zh' ? saved : 'zh'
  } catch {
    // 隐私模式下 localStorage 会抛异常，回退默认语言即可，不能 let 它白屏
    return 'zh'
  }
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
})

/** 切换语言并尝试持久化到 localStorage */
export function setLocale(locale: AppLocale) {
  i18n.global.locale.value = locale
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // 无法持久化就只在本次会话生效
  }
}
